import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["corner", _ctx.className]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick()))
  }, null, 2))
}